// extracted by mini-css-extract-plugin
module.exports = {"addResources":"AddResources_addResources__1pHRs","warning":"AddResources_warning__1O_e9","title":"AddResources_title__367rs","roomIcon":"AddResources_roomIcon__3Zw2v"};